import { sanitizeUrl, hasSellerLink } from './analyticsUrl.js';
// Small consent gate only. Google integration and data handling stay in a lazy chunk.
export const measurementId = (import.meta.env.VITE_GA_MEASUREMENT_ID || '').trim();
const privatePath = path => /^\/(admin|dashboard|leader|seller|association|group-admin|onboarding|auth|register-seller|fortnox)/i.test(path);
let granted = false, api, pending;
const landingURL = typeof window === 'undefined' ? '' : sanitizeUrl(window.location.href);
const sellerLink = typeof window !== 'undefined' && hasSellerLink(window.location.href);
const configured = /^G-[A-Z0-9]+$/.test(measurementId);
const allowed = () => configured && granted && typeof window !== 'undefined' && !privatePath(window.location.pathname);
export function setAnalyticsConsent(value) {
  if (!configured || typeof window === 'undefined') return;
  const revoked = granted && !value;
  granted = value === true;
  window[`ga-disable-${measurementId}`] = !granted || (api ? !api.isPublicAnalyticsPath(window.location.href) : privatePath(window.location.pathname));
  if (revoked) api?.revokeAnalytics();
  else if (granted) api?.loadAnalytics();
}
async function getAPI() {
  if (!allowed()) return null;
  pending ||= new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)))
    .then(() => allowed() ? import('./analytics.js') : null);
  try {
    api = await pending;
    if (!api) { pending = undefined; return null; }
    api.initializeAnalytics({ id: measurementId, allowed, landingURL, sellerLink });
    return allowed() ? api : null;
  } catch { return null; } // Analytics must never block navigation or checkout.
}
const call = (name, ...args) => {
  if (allowed()) void getAPI().then(module => module?.[name](...args)).catch(() => {});
};
export const track = (event, params) => call('track', event, params, {url:window.location.href});
export const analyticsPageView = nav => call('pageView', nav);
export const rememberCheckout = (ref, summary) => call('rememberCheckout', ref, summary);
export const reportPurchase = (ref, result) => call('reportPurchase', ref, result);
